import axios from 'axios';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import qs from 'qs';
import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import { LOCATION_CHANGE } from 'react-router-redux';

const SET_API_ERROR = 'apiErrors/SET_API_ERROR';
const REMOVE_API_ERROR = 'apiErrors/REMOVE_API_ERROR';
/**
 * @param {object} options
 * @param {string|array} options.uri - request uri
 * @param {string} options.method - request method
 * @param {array} options.actions - actions type for http request lifecycle
 * @param {object || array} options.data - request data
 * @params {object} options.addToResponse - mixin additional data to response object (mixinData)
 *
 * @return {function}
 */
export default (options) => {
	const { url, method, actions:[ SUCCESS, ERROR ], data = {}, addToResponse = {}, query = {} } = options;
	return dispatch => {
		if (isString(url)) {
			return makeRequest(url, method, data, query)
				//todo remove mixin from payload
				.then(res => dispatch(requestSuccess(SUCCESS, mixinToPayload(res, addToResponse), addToResponse)))
				.catch(error => {
					if (process.env.CPA_ENV === 'everad' && process.env.NODE_ENV === 'production') {
						Rollbar && Rollbar.warning(error.message || 'Error on API request', error);
					}
					actions.setApiError(error, ERROR)(dispatch);
					return dispatch(requestError(ERROR, error, addToResponse));
				});
		}

		if (isArray(url) && url.length) {
			const series = url.map((itemUrl, index) => {
				const requestData = isArray(data) ? data[index] : data;
				return makeRequest(itemUrl, method, requestData, query);
			});
			return axios.all(series)
				.then(res => dispatch(requestSuccess(SUCCESS, res, addToResponse)))
				.catch(error => {
					if (process.env.CPA_ENV === 'everad' && process.env.NODE_ENV === 'production') {
						Rollbar && Rollbar.warning(error.message || 'Error on API request', error);
					}
					actions.setApiError(error, ERROR)(dispatch);
					return dispatch(requestError(ERROR, error, addToResponse));
				});
		}
	};
};

const makeRequest = (url, method, data, query) => {
	//todo fix this when admin localization will be present
	const totalQuery = qs.stringify(typeof query === 'object' ? {...query, lang: 'en'} : {lang: 'en'});
	url = url.indexOf('?') > -1 ? `${url}&${totalQuery}` : `${url}?${totalQuery}`;

	return axios({url, method, [method === 'get' ? 'params' : 'data']: data});
};

// request lifecycle actions
const requestSuccess = (type, payload, meta = null) => ({ type, payload, meta });
const requestError = (type, payload, meta = null) => ({ type, payload, meta});

// add data to payload
const mixinToPayload = (payload, mixinData) => ({ ...payload, mixinData });
const initialState = [];
export const actions = Object.assign({
	setApiError: (error, ACTION_TYPE) => dispatch => {
		const timeout = ACTION_TYPE === 'root/fetch-data-error'? 1000: 9000;
		setTimeout(() => dispatch(actions.removeApiErrors()), timeout);
		dispatch({
			type: SET_API_ERROR,
			payload: {
				error: JSON.stringify(error),
				message: error.message,
				actionType: ACTION_TYPE
			}
		});
	},
	removeApiErrors: () => ({type: REMOVE_API_ERROR})
});

const reducers = Object.assign({
	[SET_API_ERROR]:(state, action) => {
		return [...state, action.payload];
	},
	[REMOVE_API_ERROR]:(state, action) => {
		return [...initialState];
	},
	[LOCATION_CHANGE]:(state, action) => {
		return [...initialState];
	}
});
export const errorReducer = handleActions(reducers, cloneDeep(initialState));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/http.js